import Icon from '@components/shared/Icon'

import styles from 'styles/display/MoreButton.module.css'

export default function MoreButton ({ onClick, shown = false }) {
    return (
        <button
            className={styles.more}
            onClick={onClick}>

                <Icon>{ shown ? 'expand_less' : 'more_horiz' }</Icon>
        </button>
    )
}